export interface IPrinter {
  id: number;
  appUrl: string;
  env: string;
  communication: string;
  defaultUrl: string;
  ip: string;
  port: string;
  noOfPrints: number;
}

export const defaultPrinter: IPrinter = {
  id: 0,
  env: "windows",
  defaultUrl: "https://print.waepos.com/print?app=epos",
  appUrl: "default",
  communication: "standard",
  ip: "192.168.2.5",
  port: "9100",
  noOfPrints: 0,
};
